import {Body2, DisplayH1} from "pu-crossproduct-components/build/components/Atoms/Type";
import React from "react";
import {ScoodleDefaultPage} from "../../../04templates/scoodle/defaultPage/ScoodleDefaultPage";
import {Trans, useTranslation} from "react-i18next";
import {GridContainer, GridItem, GridRow} from "pu-crossproduct-components/build/components/Atoms/Grid";

export const Scoodle404: React.FC = props => {
    const {t} = useTranslation();
    return <ScoodleDefaultPage>
        <DisplayH1><Trans t={t}>error404Title</Trans></DisplayH1>
        <Body2><Trans t={t}>error404Description</Trans></Body2>
    </ScoodleDefaultPage>
}
